import React from 'react';
import { connect } from 'react-redux';
import styles from './Common.module.css';
import { PatientCareCenterNoteGoalsFotoRow } from './FotoRow';
import { PatientCareCenterNoteGoalsGoalShortTermGoals } from './ShortTermGoals'
import { PatientCareCenterNoteGoalsLTGs } from './LTGs';
import { PatientCareCenterNoteGoalsFreeForm } from './FreeFormGoals';

class PatientCareCenterNoteGoalsBody extends React.Component {

    render() {

        return (
            <div>
                {this.props.fotoActivities.length > 0 &&
                    <div>
                        <div className={styles.foto_header_row}>
                            <div className={styles.foto_inset} />
                            <div className={styles.foto_header1}>FOTO Activities</div>
                            <div className={styles.foto_header2}>Current Limitation</div>
                        </div>

                        {Object.keys(this.props.fotoActivities)
                            .map(key => {
                                const result = this.props.fotoActivities[key];
                                return (
                                    <PatientCareCenterNoteGoalsFotoRow key={result.FOTOPRNO} id={result.FOTOPRNO} />
                                )
                            })
                        }
                    </div>
                }

                <PatientCareCenterNoteGoalsGoalShortTermGoals />
                <PatientCareCenterNoteGoalsLTGs subjectiveRefProp={this.props.subjectiveRefProp} />
                <PatientCareCenterNoteGoalsFreeForm />
            </div>
        );
    }

}


function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);

    return {
        fotoActivities: Object.keys(state.entities.notes.FOTOPATIENTRESPONSE)
            .filter(key => {
                return (noteType === 1 && state.entities.notes.FOTOPATIENTRESPONSE[key].PREVNO === pk) ||
                    (noteType !== 1 && state.entities.notes.FOTOPATIENTRESPONSE[key].PRNTNO === pk)
            })
            .sort((a, b) => state.entities.notes.FOTOPATIENTRESPONSE[a].FOTOPRNO - state.entities.notes.FOTOPATIENTRESPONSE[b].FOTOPRNO)
            .map(key => state.entities.notes.FOTOPATIENTRESPONSE[key]),
    };
}

const connectedPatientCareCenterNoteGoalsBody = connect(mapStateToProps)(PatientCareCenterNoteGoalsBody);
export { connectedPatientCareCenterNoteGoalsBody as PatientCareCenterNoteGoalsBody };

